var map = {
	"./de-BE.json": [
		35820,
		5820
	],
	"./de-NL.json": [
		14783,
		4783
	],
	"./en-GB.json": [
		76348,
		6348
	],
	"./fr-BE.json": [
		87485,
		7485
	],
	"./nl-BE.json": [
		60979,
		979
	],
	"./nl-NL.json": [
		9024,
		9024
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 10995;
module.exports = webpackAsyncContext;